import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentEmpleados } from '@environments/environment';
import { Alert } from '@app/_models';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class CertificateService {
    alertas: Alert[];
    constructor(private http: HttpClient,) 
    {
        this.alertas = [];
     }

     agregarCertificado(json){
        return this.http.post<any>(`${environmentEmpleados.apiUrl}/Certificate/CurrentUser`,json);
     }

     editarCertificado(json){
        return this.http.put<any>(`${environmentEmpleados.apiUrl}/Certificate/CurrentUser`,json);
     }
    
     getCertificate() {

        return this.http.get<any>(`${environmentEmpleados.apiUrl}/Certificate/CurrentUser`);
    }

    getCertificateType() {

        return this.http.get<any>(`${environmentEmpleados.apiUrl}/CertificationType`);
    }



}
